import createLogger from '@/lib/logger'

import {
  getPostAuthRedirect,
  isPostAuthLandingRoute,
} from '../postAuthRedirect'

import type { RouteLocationNormalized } from 'vue-router'

const logger = createLogger('lastVisitedRouteGuard')

/**
 * Puts the user back on the page they opened before the Keycloak round trip.
 *
 * Scoped to the post-auth landing page ({@link isPostAuthLandingRoute}). It used to
 * run on EVERY navigation, consuming the saved route wherever the user happened to
 * be going — so a leftover `post-auth-redirect` hijacked an explicit visit to a
 * shared link (`/public/gpt/:token`, `/w/:slug`), and a visitor without EverGPT
 * access ended up on /not-authorised for a page that is meant to be open to them.
 */
export const lastVisitedRouteGuard = async (to: RouteLocationNormalized) => {
  logger.log('Running hook...')

  if (!isPostAuthLandingRoute(to)) return

  const lastVisitedRoute = getPostAuthRedirect(true)
  if (!lastVisitedRoute) return

  const url = new URL(lastVisitedRoute, window.location.origin)
  logger.log(`Last visited route: ${url}`)

  // Parse query string into an object
  const queryParams = new URLSearchParams(url.search)
  const query: Record<string, string> = {}
  queryParams.forEach((value, key) => {
    query[key] = value
  })

  return { path: url.pathname, query }
}
